module.exports = __webpack_public_path__ + "img/China.ce594d9a.png";